
    var riot = require('riot')
    
import _ from 'lodash'
riot.tag2('saijiki-calendar-header', '<div class="c-saijiki-calendar__header"> <div class="c-saijiki-calendar__intro"> <div class="c-saijiki-calendar__intro-texts"> <div>基本的に毎週月曜日と木曜日に更新します。</div> <div>場所名をクリックすると詳細情報にリンクします。</div> </div> <div class="c-saijiki-calendar__intro-stats"> <ul> <li each="{i, key in opts.state.treeStates}"> <div class="c-saijiki-calendar__icon" riot-style="{setSakuraIcon(key)};"></div><span>{i.name}</span> </li> </ul> </div> </div> </div>', '', '', function(opts) {
    const self = this
    self.kind = self.opts.state.kind

    self.update()

    self.setMainImage = () => {
      return `background-image: url('/design/img/main-img/${self.kind}.png')`
    }
    self.setSakuraIcon = (key) => {
      return `background-image: url('/design/img/hanasaijiki/icons/${self.kind}-${key}.png')`
    }
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/saijiki-calendar/saijiki-calendar-header.tag